import { render } from "./Colors.vue?vue&type=template&id=fe93ba3e&scoped=true"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"

import "./Colors.vue?vue&type=style&index=0&id=fe93ba3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe93ba3e"]])

export default __exports__